/**
 * Booking deposit (acompte) of transport listings (transfers and private
 * drivers): the percentages a provider can choose and the deposit the server
 * asks when the provider accepts a request.
 *
 * The listing page uses `booking_deposit_percentage`, computed by the server
 * (GET /services/{id}). `listingDepositPct` mirrors that server rule for the
 * provider's edit form, so an older listing opens on the deposit it really
 * applies (an older « deposit: on » without percentage = 50 %).
 */
import { TRANSPORT_DEPOSIT_CHOICES, toDepositChoice } from '@/lib/depositRates';

export const DEPOSIT_CHOICES = TRANSPORT_DEPOSIT_CHOICES;   // 0 / 30 / 50 (the 25 % option was replaced by 30 %)
const LEGACY_DEFAULT = 50;

const nearestChoice = (value) => toDepositChoice(value);     // a stored 25 reads as 30

export const listingDepositPct = (service) => {
  if (service?.booking_deposit_percentage != null && Number.isFinite(Number(service.booking_deposit_percentage))) {
    return Number(service.booking_deposit_percentage);
  }
  const details = service?.details || {};
  if ((details.payment_config || {}).deposit_required === false) return 0;
  const bookingDeposit = details.booking_deposit || {};
  const legacyPct = String(details.deposit_type || '').toLowerCase().trim() === 'percentage' ? details.deposit_value : null;
  const raw = bookingDeposit.value != null ? bookingDeposit.value : (legacyPct != null ? legacyPct : LEGACY_DEFAULT);
  const value = Number(raw);
  return nearestChoice(Number.isFinite(value) ? value : LEGACY_DEFAULT);
};

/** Fields saved on the listing for the chosen percentage (same shape as the airport transfer forms). */
export const depositFields = (pct) => {
  const required = pct > 0;
  return {
    payment_config: {
      deposit_required: required,
      deposit_type: required ? 'percentage' : 'none',
      deposit_percentage: pct,
    },
    booking_deposit: required ? { type: 'percentage', value: pct } : { type: 'none', value: 0 },
  };
};

/** Deposit amount in THB for a price (rounded like the server: 2 decimals). */
export const depositAmount = (price, pct) => {
  const p = Number(price);
  if (!Number.isFinite(p) || p <= 0 || !pct) return 0;
  return Math.round(p * pct) / 100;
};
